import { Disclosure } from "@headlessui/react";
import { MinusIcon, PlusIcon } from "@heroicons/react/20/solid";
import SearchIcon from '@mui/icons-material/Search';
import { useState, useEffect } from 'react';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { getAllCountries } from "../../service/MainService";

const filters = [
  {
    id: "name",
    name: "Architect Name",
  },
  {
    id: "occupation",
    name: "Occupation",
    options: [
      { value: "Professional", label: "Professionals" },
      { value: "Student", label: "Student" },
      { value: "Professor", label: "Professors" },
      { value: "Company", label: "Company" }
     
    ],
  },
  {
    id: "industry",
    name: "Industry",
    options: [
      { value: "Architecture", label: "Architecture" },
      { value: "LandscapeArchitecture", label: "Landscape Architecture" },
      { value: "InteriorDesign", label: "Interior Design" },
      { value: "ElectricalEngineering", label: "Electrical Engineering" },
      { value: "StructuralEngineering", label: "Structural Engineering" },
      { value: "CivilEngineering", label: "Civil Engineering" },
      { value: "MechanicalEngineering", label: "Mechanical Engineering" },
      { value: "GeotechnicalEngineering", label: "Geotechnical Engineering" },
      {
        value: "ConstructionandBuildingIndustry",
        label: "Construction and Building Industry",
      },
      {
        value: "UrbanandRegionalPlanning",
        label: "Urban and Regional Planning",
      },
      {
        value: "EnvironmentalandSustainabilityDesign",
        label: "Environmental and Sustainability Design",
      },
      { value: "LightingDesign", label: "Lighting Design" },
      { value: "AcousticDesign", label: "Acoustic Design" },
      {
        value: "TechnologyandInformationSystemsinArchitecture",
        label: "Technology and Information Systems in Architecture",
      },
      {
        value: "AccessibilityandInclusiveDesign",
        label: "Accessibility and Inclusive Design",
      },
      { value: "GraphicDesign", label: "Graphic Design" },
      { value: "ArchitecturalRendering", label: "Architectural Rendering" },
      { value: "ProfessionalPhotography", label: "Professional Photography" },
      { value: "BuildingMaterials", label: "Building Materials" },
    ],
  },
  {
    id: "location",
    name: "Location",
    options: [
      { value: "New York", label: "New York" },
      { value: "Los Angeles", label: "Los Angeles" },
      { value: "Chicago", label: "Chicago" },
      { value: "Houston", label: "Houston" },
      { value: "Phoenix", label: "Phoenix" },
    ],
  },
];

export const ProfessionalsFilter = ({ onFilterChange }) => {
  const [selectedFilters, setSelectedFilters] = useState({});
  const [country, setCountry] = useState([]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const CountryList = await getAllCountries();
        setCountry(CountryList);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  const handleFilterChange = (sectionId, value) => {
    let updatedFilters = { ...selectedFilters, [sectionId]: value };
    if (selectedFilters[sectionId] === value) {
      updatedFilters = { ...selectedFilters };
      delete updatedFilters[sectionId];
    }
    setSelectedFilters(updatedFilters);
    onFilterChange(updatedFilters);
  };



  return (
    <div>
      <span className="text-md text-slate-500 font-normal flex items-center gap-4"><SearchIcon /> Search Professionals</span>
      <div className="flex flex-col mt-3 lg:mt-5 p-2 gap-2">
        {filters.map((section) => (
          <Disclosure
            as="div"
            key={section.id}
            className="border-b-2 border-gray-300 py-1"
          >
            {({ open }) => (
              <>
                <h3 className="-my-2 lg:my-0 lg:flow-root">
                  <Disclosure.Button className="flex w-full items-center justify-between bg-white py-2 lg:py-3 text-sm text-gray-400 hover:text-gray-500">
                    <span className="font-semibold text-gray-900">
                      {section.name}
                    </span>
                    <span className="ml-4 flex items-center">
                      {open ? (
                        <MinusIcon className="h-5 w-5" aria-hidden="true" />
                      ) : (
                        <PlusIcon className="h-5 w-5" aria-hidden="true" />
                      )}
                    </span>
                  </Disclosure.Button>
                </h3>
                <Disclosure.Panel className="pt-3 lg:pt-6">
                  <div className="space-y-3">

                    {/* Render filters based on section */}
                    {section.id === "location" ? (
                      // Location filter
                      <select
                        value={selectedFilters[section.id]}
                        onChange={(e) =>
                          handleFilterChange(section.id, e.target.value)
                        }
                        className="w-full border border-gray-500 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
                      >
                        <option className="font-normal" value="">
                          Select
                        </option>
                        {country.map((countryOption) => (
                          <option
                            key={countryOption.id}
                            value={countryOption.CountryName}
                          >
                            {countryOption.CountryName}
                          </option>
                        ))}
                      </select>
                    ) : section.id === "name" ? (
                      <div className="relative">
                            <input
                              type="text"
                              value={selectedFilters[section.id]}
                              onChange={(e) =>
                                handleFilterChange(section.id, e.target.value)
                              }
                              placeholder="Search by name"
                              className="w-full border border-gray-500 rounded-md py-2 px-3 pr-10 shadow-sm focus:outline-none focus:border-blue-500"
                            />

                            <PersonSearchIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                          </div>
                    ) : (
                      // Other filters
                      section?.options?.map((option, optionIdx) => (
                        <div key={option.value} className="flex items-center">
                          <div>
                            <input
                              id={`filter-${section.id}-${optionIdx}`}
                              type="checkbox"
                              name={section.id}
                              value={option.value}
                              className="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out"
                              onChange={(e) =>
                                handleFilterChange(section.id, e.target.checked ? option.value : null)
                              }
                              checked={selectedFilters[section.id] === option.value}
                            />
                            <label
                              htmlFor={`filter-${section.id}-${optionIdx}`}
                              className="ml-3 text-sm lg:text-md font-normal text-gray-600"
                            >
                              {option.label}
                            </label>
                          </div>
                        </div>
                      ))
                    )}
                  </div>


                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        ))}
      </div>
    </div>
  );
};
